import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePremium } from '../contexts/PremiumContext';
import { paymentsAPI } from '../services/api';
import StitchHeader from '../components/StitchHeader';
import '../styles/Premium.css';

function Premium() {
  const navigate = useNavigate();
  const { isPremium } = usePremium();
  const [selectedPlan, setSelectedPlan] = useState('yearly');
  const [loading, setLoading] = useState(false);
  const [premiumInfo, setPremiumInfo] = useState(null);
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost/backend';

  useEffect(() => {
    if (isPremium) {
      fetchPremiumInfo();
    }
  }, [isPremium]);

  const fetchPremiumInfo = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${apiUrl}/api/premium/check.php`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await response.json();

      if (data.success) {
        setPremiumInfo(data.premium);
      }
    } catch (error) {
      console.error('Error fetching premium info:', error);
    }
  };

  const plans = [
    { id: 'monthly', name: 'ماهانه', price: 49000, period: 'هر ماه', pricePerMonth: 49000 },
    { id: '6months', name: 'شش‌ماهه', price: 249000, period: '۶ ماه', savings: '۱۵٪ تخفیف', pricePerMonth: 41500, badge: 'پرتقاضا' },
    { id: 'yearly', name: 'سالانه', price: 449000, period: '۱۲ ماه', savings: '۲۴٪ تخفیف', pricePerMonth: 37417, badge: 'محبوب‌ترین انتخاب', popular: true }
  ];

  const features = [
    { icon: 'all_inclusive', text: 'تست‌های نامحدود', free: '۳ تست', premium: 'نامحدود' },
    { icon: 'favorite', text: 'دسته همسر/نامزد', free: 'ندارد', premium: 'دارد' },
    { icon: 'query_stats', text: 'تست عمیق', free: '۱۰ سؤال', premium: '۳۰ سؤال' },
    { icon: 'edit_note', text: 'تست سفارشی', free: 'ندارد', premium: 'دارد' },
    { icon: 'photo_camera', text: 'استوری اینستاگرام', free: '۱ قالب', premium: '۱۰+ قالب' },
    { icon: 'monitoring', text: 'گزارش پیشرفته', free: 'ساده', premium: 'کامل + نمودار' }
  ];

  const selectedPlanInfo = plans.find((plan) => plan.id === selectedPlan);

  const handleSubscribe = async () => {
    setLoading(true);

    try {
      const response = await paymentsAPI.create(selectedPlan);
      if (!response.data?.success) {
        throw new Error(response.data?.error || 'ثبت درخواست پرداخت ناموفق بود.');
      }
      alert('درگاه پرداخت فعلاً در دسترس نیست. درخواست شما ثبت شد و به‌محض فعال‌شدن درگاه اطلاع می‌دهیم.');
    } catch (error) {
      console.error('Subscribe error:', error);
      alert(error.response?.data?.error || error.message || 'ثبت درخواست پرداخت ناموفق بود.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="premium-container">
      <StitchHeader />

      <main className="premium-main">
        <div className="premium-page-bar">
          <div className="premium-page-title">
            <span className="premium-page-avatar material-symbols-outlined">workspace_premium</span>
            <h1>نسخه حرفه‌ای را فعال کنید</h1>
          </div>
          <button className="premium-close-page material-symbols-outlined" onClick={() => navigate(-1)} type="button" aria-label="بستن">close</button>
        </div>

        {isPremium && premiumInfo ? (
          <section className="premium-active-card">
            <span className="material-symbols-outlined">verified</span>
            <div>
              <h2>پریمیوم شما فعال است</h2>
              <p>{premiumInfo.days_remaining} روز از اشتراک {premiumInfo.premium_type === 'monthly' ? 'ماهانه' : premiumInfo.premium_type === '6months' ? 'شش‌ماهه' : 'سالانه'} باقی مانده است.</p>
            </div>
          </section>
        ) : (
          <>
            <section className="premium-hero">
              <div className="premium-hero-icon material-symbols-outlined">workspace_premium</div>
              <h2>تجربه‌ای بی‌نهایت</h2>
              <p>با نسخه حرفه‌ای، محدودیت‌ها را کنار بزنید و لذت واقعی بازی را تجربه کنید.</p>
            </section>

            <section className="premium-benefit-grid" aria-label="مزایای پریمیوم">
              <article><span className="material-symbols-outlined">all_inclusive</span><strong>سؤالات نامحدود</strong></article>
              <article><span className="material-symbols-outlined premium-benefit-secondary">block</span><strong>بدون تبلیغات</strong></article>
              <article><span className="material-symbols-outlined premium-benefit-tertiary">query_stats</span><strong>گزارش‌های پیشرفته</strong></article>
              <article><span className="material-symbols-outlined premium-benefit-gold">category</span><strong>دسته‌بندی‌های اختصاصی</strong></article>
            </section>

            <section className="premium-plan-section">
              <div className="premium-section-heading">
                <h2>پلن مناسب خودت را انتخاب کن</h2>
                <p>هر زمان خواستی می‌توانی اشتراکت را تمدید کنی.</p>
              </div>

              <div className="premium-plan-picker" role="radiogroup" aria-label="انتخاب پلن">
                {plans.map((plan) => (
                  <button
                    key={plan.id}
                    className={`premium-plan-option${selectedPlan === plan.id ? ' is-selected' : ''}${plan.popular ? ' is-popular' : ''}`}
                    onClick={() => setSelectedPlan(plan.id)}
                    type="button"
                    role="radio"
                    aria-checked={selectedPlan === plan.id}
                  >
                    {plan.badge && <span className="premium-plan-badge">{plan.badge}</span>}
                    <span className="premium-plan-name">{plan.name}</span>
                    <span className="premium-plan-mini-price">{plan.price.toLocaleString('fa-IR')} تومان</span>
                    <span className="material-symbols-outlined premium-plan-check">check_circle</span>
                  </button>
                ))}
              </div>

              <article className="premium-price-card">
                {selectedPlanInfo.popular && <span className="premium-popular-label">محبوب‌ترین انتخاب</span>}
                <div className="premium-price-card-top">
                  <div>
                    <h3>اشتراک {selectedPlanInfo.name}</h3>
                    <p>پرداخت یک‌باره برای {selectedPlanInfo.period}</p>
                  </div>
                  <div className="premium-price-value">
                    <strong>{selectedPlanInfo.price.toLocaleString('fa-IR')}</strong>
                    <span>تومان</span>
                  </div>
                </div>
                <div className="premium-price-divider" />
                <div className="premium-price-points">
                  {selectedPlanInfo.savings && <span><i className="material-symbols-outlined">check_circle</i>{selectedPlanInfo.savings} نسبت به ماهانه</span>}
                  <span><i className="material-symbols-outlined">check_circle</i>دسترسی آنی به تمام امکانات</span>
                  <span><i className="material-symbols-outlined">check_circle</i>میانگین ماهانه {selectedPlanInfo.pricePerMonth.toLocaleString('fa-IR')} تومان</span>
                </div>
              </article>
            </section>

            <section className="premium-feature-section">
              <div className="premium-section-heading">
                <h2>امکاناتی برای بازی جذاب‌تر</h2>
              </div>
              <div className="premium-feature-table">
                <div className="premium-feature-head"><span>امکانات</span><span>رایگان</span><span>پریمیوم</span></div>
                {features.map((feature) => (
                  <div className="premium-feature-row" key={feature.text}>
                    <span><i className="material-symbols-outlined">{feature.icon}</i>{feature.text}</span>
                    <span>{feature.free}</span>
                    <strong>{feature.premium}</strong>
                  </div>
                ))}
              </div>
            </section>

            <section className="premium-trust">
              <div className="premium-avatars"><span>م</span><span>س</span><span>ر</span><b>+۱۵k</b></div>
              <p>بیش از ۱۵ هزار نفر از نسخه حرفه‌ای استفاده می‌کنند</p>
              <div><i className="material-symbols-outlined">verified_user</i>۷ روز ضمانت بازگشت وجه بی‌قید و شرط</div>
            </section>

            <section className="premium-faq">
              <h2>سؤالات متداول</h2>
              <div><strong>پرداخت چطور انجام می‌شود؟</strong><p>از طریق درگاه بانکی امن انجام می‌شود.</p></div>
              <div><strong>تمدید خودکار است؟</strong><p>خیر، تمدید اشتراک فقط با انتخاب شما انجام می‌شود.</p></div>
            </section>
          </>
        )}
      </main>

      {!isPremium && (
        <footer className="premium-bottom-actions">
          <button className="premium-subscribe-button" onClick={handleSubscribe} disabled={loading} type="button">
            {loading ? 'در حال ثبت درخواست...' : `خرید اشتراک ${selectedPlanInfo.name}`}
            <span className="material-symbols-outlined">arrow_back</span>
          </button>
          <p>پرداخت امن با درگاه بانکی</p>
        </footer>
      )}
    </div>
  );
}

export default Premium;
